import React, { useState } from "react";
import { Text, Card } from "@nextui-org/react";
import { motion } from "framer-motion";
import {
  TbChartBar,
  TbPaperBag,
  TbArrowAutofitUp,
  TbLogout,
  TbBrandAdobe,
  TbCalculator,
  TbPlus,
  TbList,
  TbCashBanknoteOff,
  TbDeviceMobile,
  TbLock,
  TbNotes,
  TbTable,
  TbChecklist,
  TbBuildingBank,
} from "react-icons/tb";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { invtryActions } from "../redux/inventorySlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MotionText = motion(Text);

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const level = useSelector((state) => state.invtry.level);
  const [shakingTile, setShakingTile] = useState(null);

  const handleLogout = () => {
    dispatch(invtryActions.revokeAuth());
    localStorage.removeItem("token");
    toast.success("Logged out successfully");
    navigate("/analytics/auth");
  };

  const actions = [
    {
      label: "Reports",
      path: "/analytics/report",
      icon: TbChartBar,
      color: "#008489", // Airbnb Teal
      bg: "#e6f3f3",
    },
    {
      label: "Inventory",
      path: "/analytics/inventory",
      icon: TbPaperBag,
      color: "#ff5a5f", // Airbnb Rausch Accent
      bg: "#fff0f1",
    },
    {
      label: "HOI",
      path: "/analytics/inventory2",
      icon: TbPaperBag,
      color: "#3b5998", // HOI Deep Blue
      bg: "#edf0f5",
    },
    {
      label: "SUNIL",
      path: "/analytics/inventory3",
      icon: TbPaperBag,
      color: "#ffb400", // Sunil Gold
      bg: "#fffdf0",
    },
    {
      label: "3H Inventory",
      path: "/analytics/inventory4",
      icon: TbPaperBag,
      color: "#7b00c7", // ThreeH Purple
      bg: "#f5ebfc",
    },
    {
      label: "2H Inventory",
      path: "/analytics/inventory-2h",
      icon: TbDeviceMobile,
      color: "#00a699", // 2H Turquoise
      bg: "#e6f6f5",
    },
    {
      label: "Daily PDF",
      path: "/analytics/pdfs",
      icon: TbBrandAdobe,
      color: "#e1251b", // Adobe PDF Red
      bg: "#fceaea",
      premiumOnly: true,
    },
    {
      label: "Calculator",
      path: "/analytics/calculator",
      icon: TbCalculator,
      color: "#484848", // Charcoal
      bg: "#f2f2f2",
      premiumOnly: true,
    },
    {
      label: "Udhar",
      path: "/analytics/udhars",
      icon: TbCashBanknoteOff,
      color: "#d93900", // Udhar Crimson
      bg: "#fdf0ec",
    },
    {
      label: "New Entries",
      path: "/analytics/alt-entries",
      icon: TbNotes,
      color: "#6366f1",
      bg: "#eef2ff",
    },
    {
      label: "Cleared Entries",
      path: "/analytics/alt-cleared-entries",
      icon: TbChecklist,
      color: "#10b981",
      bg: "#e6f4ea",
    },
    {
      label: "Alt Ledger",
      path: "/analytics/alt-entries-ledger",
      icon: TbTable,
      color: "#0891b2",
      bg: "#ecfeff",
    },
    {
      label: "Banks",
      path: "/analytics/banks",
      icon: TbBuildingBank,
      color: "#2563eb",
      bg: "#eff6ff",
    },
    {
      label: "Add Product",
      path: "/analytics/add",
      icon: TbPlus,
      color: "#00a699", // Turquoise
      bg: "#e6f6f5",
    },
    {
      label: "View Products",
      path: "/analytics/view",
      icon: TbList,
      color: "#008489", // Airbnb Teal
      bg: "#e6f3f3",
    },
    {
      label: "Updates",
      path: "https://scan.mrsaini.com",
      icon: TbArrowAutofitUp,
      color: "#008489", // Airbnb Teal
      bg: "#e6f3f3",
      external: true,
    },
    {
      label: "Logout",
      action: handleLogout,
      icon: TbLogout,
      color: "#e1251b", // Red
      bg: "#fceaea",
    },
  ];

  return (
    <motion.div className="alignDivCenter homeDiv">
      <ToastContainer />
      <MotionText h2>Marvans</MotionText>
      
      <div className="tileGrid">
        {actions.map((action, idx) => {
          const isLocked = action.premiumOnly && level !== "premium";
          const Icon = action.icon;
          const isShaking = shakingTile === action.label;

          const handleCardClick = (e) => {
            if (isLocked) {
              e.preventDefault();
              setShakingTile(action.label);
              setTimeout(() => {
                setShakingTile(null);
              }, 400);
              toast.error(`${action.label} is only available to Premium accounts.`);
            } else if (action.action) {
              e.preventDefault();
              action.action();
            }
          };

          const tileContent = (
            <>
              <div className="iconBox">
                <Icon size={24} />
                {isLocked && (
                  <div className="lockBadge">
                    <TbLock size={10} />
                  </div>
                )}
              </div>
              <Text className="tileLabel">{action.label}</Text>
            </>
          );

          const styleVars = {
            "--i": idx,
            "--tile-color": action.color,
            "--tile-bg": action.bg,
          };

          let className = `homeTile ${isShaking ? "shake" : ""}`;
          if (isLocked) {
            className += " lockedTile";
          }

          if (isLocked || action.action) {
            return (
              <div
                key={action.label}
                className={className}
                onClick={handleCardClick}
                style={styleVars}
              >
                {tileContent}
              </div>
            );
          }

          if (action.external) {
            return (
              <a
                key={action.label}
                href={action.path}
                target="_blank"
                rel="noopener noreferrer"
                className={className}
                style={styleVars}
              >
                {tileContent}
              </a>
            );
          }

          return (
            <Link
              key={action.label}
              to={action.path}
              className={className}
              style={styleVars}
            >
              {tileContent}
            </Link>
          );
        })}
      </div>
    </motion.div>
  );
};

export default Home;
